import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { LoaderComponent } from '../../servicios/loader/loader.component';
import { SeleccionService } from '../../servicios/seleccion.service';
import { ToolsService } from '../../recursos/tools.service';
import { IngresoService } from '../../servicios/ingreso.service';
import { AlertifyService } from 'src/app/recursos/alertify.service';
import { Router } from '@angular/router';
import { configuracion } from '../../recursos/config.service';
import { recursosCompartido } from '../../recursos/cosumoGeneral.service';

@Component({
  selector: 'app-lista-becarios',
  templateUrl: './lista-becarios.component.html',
  styleUrls: ['./lista-becarios.component.css']
})
export class   ListaBecariosComponent implements OnInit {

  public mr: NgbModalRef;
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  public dtTrigger: Subject<any>;

  public vecParametro = []; public vecFacultad = []; public vecCarrera = []; public vecPostulante = []; vecTodasCarrera = [];
  public selectPeriodo: string = ''; public buscar: string = ''; public opEditable: boolean = true; public vecNotifica = [];
  public encabezado: string = ""; public nombreBeca: string = ""; public vecPeriodo = [];
  public vecEstPostula = []; private perActual = ''; public vecAjustes: Array<any> = [];

  constructor(private cargando: LoaderComponent, private srvSelect: SeleccionService, private tools: ToolsService, private confMensaje: configuracion,
    private modalService: NgbModal, private srvInsert: IngresoService, private alerti: AlertifyService, private ruta: Router, private srvGeneral: recursosCompartido) { }

  async ngOnInit() {
    this.encabezado = "Lista de estudiantes postulantes";
    this.nombreBeca = localStorage.getItem('modNom');
    this.cargarPeriodos();
    this.cargarFacultades();
    this.cargarTodasFacultades();
    this.dtOptions[0] = this.tools.OpcionesTabla(10);
    this.dtTrigger = new Subject();
  }
  //FUNCION QUE CARGA TODAS LAS FACULTADES DE LA INSTITUCION
  async cargarPeriodos() {
    this.vecAjustes = [];
    this.vecPeriodo = []; this.perActual = 'na'
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionCarreras(3, 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      this.selectPeriodo = res.carrera[0]['strCodigo'];
      for (let objCar of res.carrera) {
        this.vecPeriodo.push({
          codigo: objCar.strCodigo, descripcion: objCar.strDescripcion, inicio: objCar.dtFechaInic, fin: objCar.dtFechaFin
        });
      }
    }
    //OBTENER EL PERIODO VIGENTE EN CASO DE HABER
    const resPer = await new Promise<any>(resolve =>
      this.srvSelect.gestionCarreras(10, 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resPer.success) {
      this.perActual = resPer.carrera[0].strCodigo;
      //OBTENER LOS AJUSTES PARA EL TIPO DE BECA SELECCIONADO
      const resAjuste = await new Promise<any>(resolve =>
        this.srvSelect.gestionBecas(14, localStorage.getItem('modBeca'), resPer.carrera[0].strCodigo, 'na').subscribe(translated => {
          resolve(translated)
        }));
      if (resAjuste.success)
        this.vecAjustes.push({ resultado: true, ajuste: resAjuste.becas })
      else
        this.vecAjustes.push({ resultado: false })
    }
  }
  //FUNCION QUE CARGA TODAS LAS FACULTADES DE LA INSTITUCION
  async cargarFacultades() {
    this.vecFacultad = [];
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionCarreras(1, 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      this.vecFacultad.push({
        codigo: 0, nombre: 'Todas las facultades'
      });
      for (let objFac of res.carrera) {
        this.vecFacultad.push({
          codigo: objFac.strCodigo, nombre: objFac.strNombre
        });
      }
    }
  }
  //FUNCION QUE CARGA TODAS LAS CARRERAS DADA UNA FACULTAD DE LA INSTITUCION
  async cargarCarreras(facultad) {
    this.vecCarrera = [];
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionCarreras(2, facultad, 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      this.vecCarrera.push({
        codigo: 0, nombre: 'Todas las carreras', base: 'na', unico: 'na'
      });
      for (let objCar of res.carrera) {
        this.vecCarrera.push({
          codigo: objCar.codCarrera, nombre: objCar.nombCarrera.replace('.', '(REDISEÑO)'),
          base: objCar.strBaseDatos, unico: objCar.carrera_unica
        });
      }
    }
  }
  //FUNCION PARA ABRIR EL MODAL QUE PERMITE EDITAR UN REQUISITO
  modalPostulante(nameMod) {
    if (localStorage.getItem('modUser') == 'true') {
      this.inicarParametro();
      this.mr = this.modalService.open(nameMod);
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  async modalPreAprueba(modalName, postula) {
    this.obtenerDatosCentralizada(postula.cedula.replace('-', ''));
    const resPostula = await new Promise<any>(resolve =>
      this.srvSelect.gestionBecas(12, postula['idPostula'], 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resPostula.success) {
      this.instaciaEstAprobacion(resPostula.becas[0]['intIdAplica'], resPostula.becas[0]['intEstado'], resPostula.becas[0]['intEstado'] == 1 ?
        resPostula.becas[0]['strResolucion'] : resPostula.becas[0]['strObservacion'], resPostula.becas[0]['strPeriodo']);
      this.mr = this.modalService.open(modalName);
    }
  }
  //INSTANCIAR EL VECTOR QUE TIENE LA INFORMACION DEL ESTADO DE APROBACION
  instaciaEstAprobacion(dato1, dato2, dato3, dato4) {
    this.vecEstPostula = [];
    this.vecEstPostula.push({ idEstPostula: dato1, estPostula: dato2, obsPostula: dato3, edita: dato4 == this.perActual ? dato2 == 1 ? true : false : true });
  }
  //FUNCION PARA INSTANCIAR EL VECTOR DE PARAMETROS
  inicarParametro() {
    this.vecParametro = [];
    this.vecParametro.push({
      facultad: 0, carrera: 0, periodo: this.selectPeriodo
    })
  }
  //FUNCION QUE MUESTRA EL REPORTE REPORTE DE POSTULANTES
  verPostulantes() {
    if (this.vecParametro[0]['facultad'] == 0)
      this.cargarPostulaFacultad(3, this.vecParametro[0]['periodo'], this.vecParametro[0]['facultad'], localStorage.getItem('modBeca'));
    else {
      if (this.vecParametro[0]['carrera'] == 0)
        this.cargarPostulaFacultad(2, this.vecParametro[0]['periodo'], this.vecParametro[0]['facultad'], localStorage.getItem('modBeca'));
      else
        this.cargarPostulaCarrera(this.vecParametro[0]['periodo'], this.vecParametro[0]['carrera'], localStorage.getItem('modBeca'));
    }
  }
  //FUNCION QUE CARGA TODOS LOS REQUISITOS ESPECIFICOS DEL TIPO DE BECA SELECCIONADO
  async cargarPostulaFacultad(opcion, periodo, facultad, beca) {
    this.cargando.abrir();
    var tblPostulantes = $('#tblPostulantes').DataTable({
      destroy: true
    });
    tblPostulantes.destroy();
    this.vecPostulante = [];

    const resFac = await new Promise<any>(resolve => this.srvSelect.gestionPostulantes(opcion, periodo, facultad, beca, 'na').subscribe(translated => { resolve(translated) }));

    if (resFac.success) {
      for (let objFacultad of resFac.postula) {
        const resMaster = await new Promise<any>(resolve => this.srvSelect.gestionCarreras(4, objFacultad.strCarrera, 'na', 'na').subscribe(translated => { resolve(translated) }));
        if (resMaster.success) {
          const resPostula = await new Promise<any>(resolve => this.srvSelect.gestionPostulantes(1, periodo, resMaster.carrera[0]['codigoCarrera'], beca, 'na').subscribe(translated => { resolve(translated) }));
          if (resPostula.success) {
            for (let objPost of resPostula.postula) {
              const resMatricula = await new Promise<any>(resolve => this.srvSelect.gestionMatricula(2, resMaster.carrera[0]['baseCarrera'], objPost.codigoEstudiante, periodo, 'na').subscribe(translated => { resolve(translated) }));
              if (resMatricula.success) {
                this.vecPostulante.push({
                  idPostula: objPost.intIdAplica, facultad: resMaster.carrera[0]['nombreFacultad'], carrera: resMaster.carrera[0]['nombreCarrera'],
                  cedula: resMatricula.matricula[0]['strCedula'], nombres: resMatricula.matricula[0]['strNombres'], apellidos: resMatricula.matricula[0]['strApellidos'],
                  nivel: resMatricula.matricula[0]['strCodNivel'], enviado: objPost.intEnviado == 1 ? 'Completado' : 'Incompleto',
                  lblEstado: objPost.intEstado == 1 ? 'Aprobado' : objPost.intEstado == 2 ? 'Pre-aprobado' :
                    objPost.intEstado == 3 ? 'Pendiente' : 'Rechazado', estado: objPost.intEstado, perPostula: periodo,
                  sexo: resMatricula.matricula[0]['strCodSexo'] == 'MAS' ? 'MASCULINO' : 'FEMENINO', observacion: objPost.strObservacion
                });
              }
            }
          }
        }
      }
    }
    this.dtTrigger.next();
    this.cerrarModal();
    this.cargando.cerrar();
  }
  //FUNCION QUE CARGA TODOS LOS REQUISITOS ESPECIFICOS DEL TIPO DE BECA SELECCIONADO
  async cargarPostulaCarrera(periodo, codCarrera, beca) {
    this.cargando.abrir();
    var tblPostulantes = $('#tblPostulantes').DataTable({
      destroy: true
    });
    tblPostulantes.destroy();
    this.vecPostulante = [];

    const resMaster = await new Promise<any>(resolve =>
      this.srvSelect.gestionCarreras(4, codCarrera, 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resMaster.success) {

      const resPostula = await new Promise<any>(resolve =>
        this.srvSelect.gestionPostulantes(1, periodo, codCarrera, beca, 'na').subscribe(translated => {
          resolve(translated)
        }));
      if (resPostula.success) {
        for (let objPos of resPostula.postula) {
          const resMatricula = await new Promise<any>(resolve =>
            this.srvSelect.gestionMatricula(2, resMaster.carrera[0]['baseCarrera'], objPos.codigoEstudiante, periodo, 'na').subscribe(translated => {
              resolve(translated)
            }));
          if (resMatricula.success) {
            this.vecPostulante.push({
              idPostula: objPos.intIdAplica, facultad: resMaster.carrera[0]['nombreFacultad'], carrera: resMaster.carrera[0]['nombreCarrera'],
              cedula: resMatricula.matricula[0]['strCedula'], nombres: resMatricula.matricula[0]['strNombres'], apellidos: resMatricula.matricula[0]['strApellidos'],
              nivel: resMatricula.matricula[0]['strCodNivel'], enviado: objPos.intEnviado == 1 ? 'Completado' : 'Incompleto',
              lblEstado: objPos.intEstado == 1 ? 'Aprobado' : objPos.intEstado == 2 ? 'Pre-aprobado' :
                objPos.intEstado == 3 ? 'Pendiente' : 'Rechazado', estado: objPos.intEstado, perPostula: periodo,
              sexo: resMatricula.matricula[0]['strCodSexo'] == 'MAS' ? 'MASCULINO' : 'FEMENINO', observacion: objPos.strObservacion
            });
          }
        }
      }
    }
    this.dtTrigger.next();
    this.cerrarModal();
    this.cargando.cerrar();
  }
  verRequisito(datos) {
    localStorage.setItem('editaPost', this.perActual == datos.perPostula ? 'false' : 'true');
    localStorage.setItem('localIdPostula', datos.idPostula);
    localStorage.setItem('localPostula', datos.nombres + " " + datos.apellidos);
    this.ruta.navigate(['gestion/verReqEspecifico']);
  }
  //FUNCION QUE GUARDA EL ESTADO DE LA POSTULACION DEL ESTUDIANTE
  guardaEstPostula() {
    if (!this.vecEstPostula[0].edita) {
      if (this.vecEstPostula[0].estPostula == 1) {
        this.alerti.confirm('Usted va aprobar la postulación seleccionada, tome en cuenta que una vez aceptada la postulación usted no podrá modificar la misma, Desea continuar?', () => {
          this.gestionaEstPostula();
        });
      }
      else
        this.gestionaEstPostula();
    }
    else
      this.alerti.error('No se puede cambiar el estado de la postulación');
  }
  gestionaEstPostula() {
    if (this.vecAjustes[0].resultado) {
      this.srvInsert.ingresoGestionBecas(this.vecEstPostula[0].idEstPostula, this.vecEstPostula[0].estPostula, this.vecEstPostula[0].obsPostula, 'na', 'na', 'na', 'na',
        'na', 'na', 'na', 'na', 'na', 'na', 'na', this.vecEstPostula[0].estPostula == 1 ? 16 : 14).subscribe(res => {
          if (res.becas) {
            this.alerti.success("Estado de la beca almacenado correctamente");
            if (this.vecEstPostula[0].estPostula == 1 || this.vecEstPostula[0].estPostula == 2) {
              //CONSTRUIR EL CONTEXTO DEL CORREO
              let contenido = this.confMensaje.bodyMensaje(this.vecEstPostula[0].estPostula == 2 ? 14 : 16, this.vecNotifica[0]['nombre'], localStorage.getItem('modNom'),
                this.vecEstPostula[0].estPostula == 2 ? 'Pre-aprobado' : 'Aprobado',
                this.vecAjustes[0].ajuste[0].strMailEntregaReq, 'na');
              //ENVIO DEL CORREO
              this.srvInsert.envioMail('Postulación ' + this.nombreBeca, this.vecNotifica[0]['correo'], btoa(contenido)).subscribe(resEnvio => {
                if (resEnvio.correo)
                  this.alerti.error('No se envío la notificación. Intente de nuevo');
              });
            }
            this.cerrarModal();
            this.verPostulantes();
          }
          else
            this.alerti.error("Error al registrar los datos");
        });
    }
    else
      this.alerti.error('Este tipo de becas no tiene las configuraciones pertinentes');
  }
  //FUNCION QUE CIERRA EL MODAL
  cerrarModal() {
    this.mr.close();
  }

  //FUNCION QUE CARGA TODAS LAS FACULTADES DE LA INSTITUCION
  async cargarTodasFacultades() {
    this.vecNotifica.push({
      codEst: 0, cedEst: '', nombre: '', codPeriodo: '', periodo: '', codFacultad: '', facultad: '', codCarrera: '', carrera: '', nivel: '', correo: '', fono: '', promedio: 0
    });
    this.vecTodasCarrera = [];
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionCarreras(1, 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      for (let objCar of res.carrera)
        this.todasCarreraFaculta(objCar.strCodigo);
    }
  }

  //FUNCION QUE CARGA TODAS LAS CARRERAS QUE PERTENECE A UNA FACULTAD
  async todasCarreraFaculta(fac) {
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionCarreras(2, fac, 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      for (let objCar of res.carrera) {
        this.vecTodasCarrera.push({
          codFac: objCar.codFacultad,
          nombFac: objCar.nombFacultad,
          codCarr: objCar.codCarrera,
          nombCarr: objCar.nombCarrera,
          baseCarr: objCar.baseDatos,
        });
      }
    }
  }

  //FUNCION PARA ABRIR EL MODAL QUE PERMITE BUSCAR UN ESTUDIANTE
  bucarEstudiante(nameMod) {
    if (localStorage.getItem('modUser') == 'true') {
      this.mr = this.modalService.open(nameMod);
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  //BUSCAMOS LA MATRICULA DEL ESTUDIANTE
  async buscarEstudiante() {
    this.vecNotifica = []; this.opEditable = true;
    this.vecNotifica.push({
      codEst: 0, cedEst: '', nombre: '', codPeriodo: '', periodo: '', codFacultad: '', facultad: '', codCarrera: '', carrera: '', nivel: '', correo: '', fono: ''
    });
    let i = 0; let ban = 0;
    this.cargando.abrir();
    //OBTENER EL PERIODO ANTERIOR AL VIGENTE
    let datper: any = await this.srvGeneral.verPeriodoPosicion(1);
    let datperA: any = await this.srvGeneral.verPeriodoPosicion(0);
    //this.cerrarModal();
    if (this.buscar) {
      const resMatrCarrera = await new Promise<any>(resolve =>
        this.srvSelect.gestionMatricula(1, 'na', this.buscar, 'na', 'na').subscribe(translated => {
          resolve(translated)
        }));
      if (resMatrCarrera.success) {

        while (i < resMatrCarrera.matricula.length && ban == 0) {
          const resMatr = await new Promise<any>(resolve =>
            this.srvSelect.gestionMatricula(33, resMatrCarrera.matricula[i]['baseCarrera'], this.buscar, datper, 'na').subscribe(translated => {
              resolve(translated)
            }));
          if (resMatr.success) {
            this.vecNotifica[0]['cedEst'] = this.buscar;
            this.vecNotifica[0]['codEst'] = resMatr.matricula[0].strCodEstud;
            this.vecNotifica[0]['codPeriodo'] = datperA;
            this.vecNotifica[0]['nivel'] = resMatr.matricula[0]['strCodNivel'];
            this.vecNotifica[0]['codFacultad'] = resMatrCarrera.matricula[i]['codFacultad'];
            this.vecNotifica[0]['codCarrera'] = resMatrCarrera.matricula[i]['strCodCarrera'];

            this.vecNotifica[0]['periodo'] = resMatr.matricula[0].strCodPeriodo;
            this.vecNotifica[0]['facultad'] = resMatrCarrera.matricula[i]['nombFacultad'];
            this.vecNotifica[0]['carrera'] = resMatrCarrera.matricula[i]['nombCarrera'];
            this.vecNotifica[0]['nivel'] = resMatr.matricula[0]['strCodNivel'];

            this.obtenerDatosCentralizada(this.buscar);
            let datNota: any = await this.srvGeneral.verPromedioEstudiante(resMatrCarrera.matricula[i]['baseCarrera'], datper, resMatr.matricula[0].strCodEstud);
            this.vecNotifica[0]['promedio'] = datNota;
            ban = 1;
          }
          i++;
        }
      }
      if (ban == 0) {
        this.alerti.error('No se encontró al estudiante.');
      }
    }
    else
      this.alerti.error('Debe ingresar el número de cédula del estudiante.');
    this.cargando.cerrar();
  }
  //OBTENER LOS DATOS DEL ESTUDIANTE DE LA CENTRALIZADA
  obtenerDatosCentralizada(buscar) {
    this.srvSelect.personaCentralDocumento(buscar).subscribe(data => {
      if (data.success) {
        this.opEditable = false;
        this.vecNotifica[0]['nombre'] = data.datos['per_nombres'] + ' ' + data.datos['per_primerApellido'] + ' ' + data.datos['per_segundoApellido'];
        this.vecNotifica[0]['correo'] = data.datos['per_email'];
        this.verHistoria(buscar);
      } else {
        this.alerti.error('No se encontró al estudiante');
      }
    });
  }
  //BUSCAMOS LA HCE DEL ESTUDIANTE
  async verHistoria(estudiante) {
    const resHC = await new Promise<any>(resolve => this.srvSelect.medicoHistoriaClinica(estudiante).subscribe(translated => {
      resolve(translated)
    }));
    if (resHC.success) {
      this.vecNotifica[0]['fono'] = resHC.roles[0]['celular'];
    }
  }
  //FUNCION QUE ABRE EL MODAL CON LOS TERMINOS Y CONDICIONES
  async enviarNotificacion() {
    let perVerifica: any = localStorage.getItem('modBeca') == '1' ? await this.srvGeneral.verPeriodoAnteriosr(this.vecNotifica[0]['codPeriodo']) : this.vecNotifica[0]['codPeriodo'];

    const resPostula = await new Promise<any>(resolve =>
      this.srvSelect.gestionPostulantes(10, this.vecNotifica[0]['codEst'], perVerifica, this.vecNotifica[0]['codCarrera'], 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resPostula.success)
      this.alerti.error('El estudiante ya tiene una postulación para el período seleccionado.')
    else {
      this.alerti.confirm('A continuación va asignar una postulación de: ' + this.nombreBeca + ' al estudiante ' + this.vecNotifica[0]['nombre'] + '. Desea continuar?', () => {
        //LLAMAR A LA FUNCION QUE REALIZA EL REGISTRO DE UNA POSTULACION
        this.agregarPostulacion(12, this.vecNotifica[0]['codEst'], localStorage.getItem('modBeca'), 3, 2, 'PENDIENTE', '', this.vecNotifica[0]['codPeriodo'],
          this.vecNotifica[0]['codCarrera'], this.vecNotifica[0]['codFacultad'], this.vecNotifica[0]['nivel'], this.vecNotifica[0]['cedEst'],
          this.vecNotifica[0]['promedio'], perVerifica);
      });
    }
  }
  //FUNCION QUE PERMITE ASIGNAR UNA ACTIVIDAD Y  UNA FUNCION A UN ROL
  agregarPostulacion(opc, dato1, dato2, dato3, dato4, dato5, dato6, dato7, dato8, dato9, dato10, dato11, dato12, dato14) {
    this.srvInsert.ingresoGestionBecas(dato1, dato2, dato3, dato4, dato5, dato6, dato7, dato8, dato9, dato10, dato11, dato12, 'na', dato14, opc).subscribe(res => {
      if (res['becas'] == 'true') {
        this.enviarCorreo();
        this.cerrarModal();
      }
      else
        this.alerti.error("No se puede agregar la postulación. Intente más tarde...");
    });
  }
  //FUNCION QUE PERMITE EL ENVÍO DE CORREOS
  async enviarCorreo() {
    //CONSTRUIR EL CONTEXTO DEL CORREO
    let contenido = this.confMensaje.bodyMensaje(14, this.vecNotifica[0]['nombre'], localStorage.getItem('modNom'), 'Pre-aprobado',
      this.vecAjustes[0].ajuste[0].strMailEntregaReq, 'na');

    this.srvInsert.envioMail('Postulación ' + this.nombreBeca, this.vecNotifica[0]['correo'], btoa(contenido)).subscribe(resEnvio => {
      if (resEnvio.correo)
        this.alerti.error("Error al enviar el correo electrónico");
      else {

        this.srvInsert.ingresoGestionAuditoria(localStorage.getItem('userAudita'), localStorage.getItem('perfilAudita'), 'Asignación y notificación de becas',
          'Asigna la beca de ' + this.nombreBeca + ' al estudiante: ' + this.vecNotifica[0]['nombre'], 14, 'Cod Carrera: ' + this.vecNotifica[0]['codCarrera'] + '; Cod Periodo: '
          + this.vecNotifica[0]['codPeriodo'] + '; Cod Semestre: ' + this.vecNotifica[0]['nivel'], 1).subscribe(res => {
          });

        this.alerti.success('Notificación realizada correctamente');
      }
    });
  }
  //TERMINOS DE ACTUALIZAR LOS DATOS DE LAS POSTULACIONES
  actualizarDatos() {
    if (localStorage.getItem('idUser') == '18') {
      this.alerti.confirm('A continuación emepazará un proceso de actualización de datos. Desea continuar...?', () => {
        this.datosMigrar();
      });
    }
    else
      this.alerti.error('No puede realizar esta acción');
  }
  //LISTA DE LOS DATOS A SER ACTUALIZADOS
  async datosMigrar() {
    this.cargando.abrir();
    const resPostula = await new Promise<any>(resolve =>
      this.srvSelect.gestionBecas(13, 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resPostula.success)
      for (let objAplica of resPostula.becas) {
        if (objAplica.strFacultad == 'undefined' || objAplica.strFacultad == '' || objAplica.strFacultad == 'null'
          || objAplica.cedulaEstudiante == '' || objAplica.cedulaEstudiante == 'null' || objAplica.cedulaEstudiante == null) {

          const resCarrera = await new Promise<any>(resolve =>
            this.srvSelect.gestionCarreras(4, objAplica.strCarrera, 'na', 'na').subscribe(translated => {
              resolve(translated)
            }));

          if (resCarrera.success) {
            const resDatoMatr = await new Promise<any>(resolve =>
              this.srvSelect.gestionMatricula(2, resCarrera.carrera[0]['baseCarrera'], objAplica.codigoEstudiante, objAplica.strPeriodo, 'na').subscribe(translated => {
                resolve(translated)
              }));

            if (resDatoMatr.success) {
              this.editarDatosPostulacion(objAplica.intIdAplica, resCarrera.carrera[0]['codigoFacultad'], resDatoMatr.matricula[0]['strCedula'].replace('-', ''));
            }
          }
        }
      }
    this.cargando.cerrar();
  }

  //FUNCION QUE ACTUALIZA LOS DATOS DE UNA POSTULACION
  editarDatosPostulacion(numero, facultad, cedula) {
    this.srvInsert.ingresoGestionBecas(numero, facultad, cedula, 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 'na', 15).subscribe(res => {
      if (res.becas)
        this.alerti.success("Datos Actualizados");
      else
        this.alerti.error("Error al registrar los datos");
    });
  }

}
